
import { defineComponent, onMounted, computed, ref, inject } from 'vue'
import { errManager, showMessage } from "@/core/config/Tools";
import accService from "@/core/services/AccountService"
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useI18n } from "vue-i18n/index";

export default defineComponent({
    name: "Users",
    setup() {
        const { t } = useI18n();
        const loader = ref(false)
        const searchType = ref('')
        const searchStatus = ref('')
        const searchText = ref('')
        const setting = ref({
            types: <any>[],
            status: <any>[]
        })
        const listUsers = ref([])

        //Pagination start
        const pageSize = ref(10)
        const currentPage = ref(1)
        const totalItems = ref(0)

        const getSetting = async () => {
            await accService.getSetting()
            .then( (res) => {
                setting.value = res.data
            }).catch( ({response}) => {
                errManager(response, null, 2)
            })
        }

        const getData = async () => {
            loader.value = true
            await accService.getData({
                    search: searchText.value.trim(),
                    instype: searchType.value,
                    status: searchStatus.value,
                    pageSize: pageSize.value,
                    currentPage: currentPage.value
                })
                .then((res) => {
                    listUsers.value.length = 0
                    listUsers.value = res.data.list
                    totalItems.value = res.data.total
                    loader.value = false
                }).catch(({
                    response
                }) => {
                    listUsers.value.length = 0
                    loader.value = false
                })
        }

        const handleCurrentChange = (val: number) => {
            currentPage.value = val
            getData()
        }

        onMounted(async () => {
            getSetting()
            getData()
        })

        return {
            t,
            loader,
            searchType,
            searchStatus,
            searchText,
            setting,
            //page
            pageSize,
            currentPage,
            totalItems,
            //list
            listUsers,
            //events
            getSetting,
            getData,
            handleCurrentChange

        }
        
    },
})
